export const imgNameFormatter = (imgUrl: string) => {
  return imgUrl.match(/([^/?#]+)[^/]*$/)?.[1];
};
